import { Action, createReducer, on } from '@ngrx/store';
import * as SnackBarActions from './snack-bar.actions';
import { SnackBarModel } from './snack-bar.model';

const initialState: SnackBarModel = new SnackBarModel();
const reducer = createReducer(
  initialState,
  on(SnackBarActions.setSnackBar, (state, { snackBarSuccess, showSnackBar, snackBarMessage }) => ({
    ...state,
    snackBarSuccess,
    showSnackBar,
    snackBarMessage,
  }))
);

export function snackBarReducer(state: SnackBarModel, action: Action) {
  return reducer(state, action);
}
